import { render, staticRenderFns } from "./Dynamic.vue?vue&type=template&id=9bea2392&"
import script from "./Dynamic.vue?vue&type=script&lang=js&"
export * from "./Dynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports